import axios from "axios";
import { Button, FormControl, InputGroup, Table } from "react-bootstrap";
import "./App.css";
import React, { useEffect, useState } from "react";

function App() {
  const [pin, setPin] = useState("");
  const [service, setService] = useState([]);

  useEffect(() => {
    if (pin.length === 6) {
      getPin();
    }
    if (pin.length > 6) {
      setPin("");
    }

    return () => {
      setService([]);
    };
  }, [pin]);

  const getPin = () => {
    //SPOTON PIN #####################
    axios
      .get(`https://web1.spoton.co.in/getPincodeDetails?&Pincode=${pin}`)
      .then((resp) => {
        console.log(resp);

        let newSdata = {
          company: "Spoton",
          oda: resp.data.PincodeDetails.ExtraDeliveryDays,
          branch: resp.data.PincodeDetails.SPOTONCenter,
          type: resp.data.PincodeDetails.ServiceType,
        };
        setService((prevState) => {
          return [...prevState, newSdata];
        });
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        console.warn("error", message);
      });

    // RIVIGO PIN#################
    axios
      .post(
        `https://zoom-api.rivigo.com/serviceable/pincode/external/from/110041/to/${pin}`,
        { appName: "zoom-web-app" }
      )
      .then((resp) => {
        console.log(resp);
        let roda = "";
        let rtype = "";

        if (
          resp.data.payload.toPincodeDTO.nearestOUDelivery.locationType ===
          "BRANCH"
        ) {
          rtype = "Standard";
        }
        if (
          resp.data.payload.toPincodeDTO.deliveryServiceability.additionalTat >
          0
        ) {
          roda = "ODA";
        } else {
          roda = "Standard";
        }
        let newData = {
          company: "Rivigo",
          oda: resp.data.payload.toPincodeDTO.deliveryServiceability
            .additionalTat,
          branch: resp.data.payload.toPincodeDTO.nearestOUDelivery.locationName,
          type: roda,
        };

        setService((prevState) => {
          return [...prevState, newData];
        });
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        console.warn("error", message);
      });

    // PICKER PIN#############

    axios
      .get(
        `https://pickrr.com/location/pincode-serviceability-v3/?auth_token=c25d461cfbb555a29a385f176dbf5271145700&child_auth_token=c25d461cfbb555a29a385f176dbf5271145700&from_pincode=110041&to_pincode=${pin}`
      )
      .then((resp) => {
        // let type = "NA";
        // const fetchData = () => {
        let service = "NA";
        let fedex = false;
        let delhivery = false;
        let data = "";
        if (resp) {
          data = resp.data.surface_prepaid_pl;
        } else {
          alert("no ");
        }

        data.map((item) => {
          if (item.name === "fedex_economy") {
            fedex = true;
            service = "Fedex";
          }
          if (item.name === "delhivery_5kg") {
            delhivery = true;
            service = "Delhivery";
          }
        });
        if (fedex && delhivery) {
          service = "Fedex";
        }

        // type = service;

        let newData = {
          company: "Pickrr",
          oda: 0,
          branch: resp.data.to_city,
          type: service,
        };
        setService((prevState) => {
          return [...prevState, newData];
        });
        // };
        // fetchData();
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        console.warn("error", message);
      });
  };

  const handleChange = (e) => {
    setPin(e.target.value);
  };

  return (
    <div className="main">
      <h1>Check Pin Code</h1>
      <InputGroup size="sm" className="mb-3">
        <InputGroup.Text id="inputGroup-sizing-sm">Enter PIN</InputGroup.Text>
        <FormControl
          aria-label="Small"
          aria-describedby="inputGroup-sizing-sm"
          type="number"
          maxLength="6"
          value={pin}
          onChange={(e) => handleChange(e)}
          autoFocus={true}
        />
      </InputGroup>
      <br />

      <div>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr key="f">
              <td>Company</td>
              <td>Branch</td>
              <td>Type</td>
              <td>ODA</td>
            </tr>
          </thead>
          <tbody>
            {service.map((item) => {
              return (
                <tr key={item.company}>
                  <td>{item.company}</td>
                  <td>{item.branch}</td>
                  <td>{item.type}</td>
                  {item.oda > 0 ? (
                    <td
                      style={{
                        color: "red",
                        fontSize: "1.5rem",
                        fontWeight: "bolder",
                      }}
                    >
                      {item.oda}
                    </td>
                  ) : (
                    <td>{item.oda}</td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default App;
